import AuthService from "./api/AuthService";
import { downloadFileFromUrl } from "../utils/helpers";

export const getConsumers = async (payload, userToken) => {
    try {
        let url = '/consumers?';
        payload?.search && (url += `search=${payload.search}&`)
        payload?.companyId && (`company_id=${payload.companyId}&`)
        payload?.distinctResposibleId && (`distinct_responsible_id=${payload.distinctResposibleId}&`)

        const response = await AuthService.get(url);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar consumidores', error);

        throw error;
    }
}


export const createConsumer = async (payload, userToken) => {
    try {
        const response = await AuthService.post('/consumers', payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao adicionar consumidor', error);

        throw error;
    }
}

export const getStudentCSVMetrics = async (payload) => {
    try {
        const response = await AuthService.post('/sessions/export/csv', payload.usersData, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })
        return response.data
    } catch {
        throw new Error("Erro ao exportar relatório")
    }
}

export const getSessionData = async (payload) => {
    let url = '/sessions'

    if (payload.userId) {
        url += `/${payload.userId}`
    }

    if (payload.type === 'Students Data For Tutors') {
        url += '?type=student&'
    }

    if (payload.tutorId) {
        url += `tutor_id=${payload.tutorId}&`
    }

    if (payload.searchUserName) {
        url += `name=${payload.searchUserName}&`
    }

    if (payload.page) {
        url += `page=${payload.page}&`
    }

    if (payload.perPage) {
        url += `per_page=${payload.perPage}&`
    }
    try {
        const response = await AuthService.get(url, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        if (!response.data.data) {
            return response
        }

        return response.data
    } catch {
        throw new Error("Erro ao requisitar dados da sessão")
    }
}

export const getUserAchievements = async (payload) => {
    try {
        const response = await AuthService.get(`/users/${payload.userId}/achievements`, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        return response.data
    } catch {
        throw new Error("Erro ao requisitar Conquistas")
    }
}

export const getWeeklyPodium = async (payload) => {
    try {
        const response = await AuthService.get('/students/ranking/weekly', {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        return response.data
    } catch {
        throw new Error("Erro ao requisitar Ranking Semanal")
    }
}

export const getStudentCompetitor = async (payload) => {
    try {
        const response = await AuthService.get(`/users/${payload.userId}/competitor`, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        return response.data
    } catch (error) {
        if (error?.response?.status === 404) return null

        throw new Error("Erro ao requisitar Competidor Semanal")
    }
}

export const getConsumerDashBoard = async (payload) => {
    try {
        const response = await AuthService.get(`/sessions/${payload.userId}/dashboard?filter=${payload.timeRange}`, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        return response.data
    } catch {
        throw new Error("Erro ao requisitar DashBoard")
    }
}

export const getTutorMetrics = async (payload) => {
    try {
        const response = await AuthService.get('/tutors/metrics', {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })
        return response.data
    } catch {
        throw new Error("Erro ao requisitar métricas do Tutor")
    }
}

export const setTutorWorkLoad = async (payload) => {
    try {
        const response = await AuthService.post('/tutor-settings', payload.tutorData, {
            headers: {
                'Authorization': 'Bearer ' + payload.userToken
            }
        })

        return response.data
    } catch {
        throw new Error("Erro ao Atualizar Carga Horária!")
    }
}

export const getStudentsReportRelatedToTutor = async (tutorId) => {
    try {
        const response = await AuthService.get(`/sessions/${tutorId}/export/csv`)
        downloadFileFromUrl(response.data.url)
    } catch {
        throw new Error("Erro ao exportar CSV! Tente novamente")
    }
}

export default {
    getConsumers,
    createConsumer,
    getSessionData,
    getUserAchievements,
    getWeeklyPodium,
    getStudentCompetitor,
    getConsumerDashBoard,
    getTutorMetrics,
    setTutorWorkLoad,
    getStudentCSVMetrics,
    getStudentsReportRelatedToTutor
}